import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';

export type ITimeSlot = {
  isNonBlocking?: boolean;
  start: Date;
  end: Date;
};

@Entity()
export class TimeSlot extends AdornisEntity {
  static override _class = 'TimeSlot';

  static override resolveID(entity: any): string {
    return (entity._id ||= A.getGloballyUniqueID());
  }

  @Field(type => String, { default: v => v ?? A.getGloballyUniqueID() })
  _id!: string;

  @Field(type => Date)
  start: Maybe<Date>;

  @Field(type => Date)
  end: Maybe<Date>;

  @Field(type => Boolean, { default: v => v ?? false })
  isNonBlocking!: boolean;
}

export type IDateTimeslot = {
  _id: string;
  start: Maybe<Date>;
  end: Maybe<Date>;
  isNonBlocking: boolean;
};
